import { createFileRoute } from "@tanstack/react-router";
import EsServicePage from "@/pages/es/EsServicePage";
import { esTmsOverview } from "@/pages/es/esServiceData";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/services/tms`;

export const Route = createFileRoute("/es/services/tms")({
  head: () => ({
    meta: [
      { title: "Terapia TMS | Neuro Wellness TMS Centers of America" },
      {
        name: "description",
        content:
          "Terapia TMS (Estimulación Magnética Transcraneal) en Coral Springs, FL. Tratamiento no invasivo autorizado por la FDA para la depresión resistente al.",
      },
      { property: "og:title", content: "Terapia TMS | Neuro Wellness TMS" },
      {
        property: "og:description",
        content:
          "TMS no invasiva y autorizada por la FDA para la depresión resistente al tratamiento en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Terapia TMS | Neuro Wellness TMS" },
      {
        name: "twitter:description",
        content:
          "TMS no invasiva y autorizada por la FDA para la depresión resistente al tratamiento en Coral Springs, FL.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/services/tms"),
    ],
  }),
  component: () => <EsServicePage cfg={esTmsOverview} />,
});
